/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsUserLicense
 */
export interface ControlcenterMelcoControlCenterModelsUserLicense {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserLicense
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserLicense
     */
    subscription_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserLicense
     */
    referral_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserLicense
     */
    version_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserLicense
     */
    email_address?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoControlCenterModelsUserLicense
     */
    is_validate_only?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoControlCenterModelsUserLicense
     */
    assign_license?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserLicense
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserLicense
     */
    melco_customer_id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoControlCenterModelsUserLicense
     */
    subscription_start_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsUserLicense
     */
    affiliate_code?: string | null;
}

export function ControlcenterMelcoControlCenterModelsUserLicenseFromJSON(json: any): ControlcenterMelcoControlCenterModelsUserLicense {
    return ControlcenterMelcoControlCenterModelsUserLicenseFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsUserLicenseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsUserLicense {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'subscription_code': !exists(json, 'subscription_code') ? undefined : json['subscription_code'],
        'referral_code': !exists(json, 'referral_code') ? undefined : json['referral_code'],
        'version_id': !exists(json, 'version_id') ? undefined : json['version_id'],
        'email_address': !exists(json, 'email_address') ? undefined : json['email_address'],
        'is_validate_only': !exists(json, 'is_validate_only') ? undefined : json['is_validate_only'],
        'assign_license': !exists(json, 'assign_license') ? undefined : json['assign_license'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'melco_customer_id': !exists(json, 'melco_customer_id') ? undefined : json['melco_customer_id'],
        'subscription_start_date': !exists(json, 'subscription_start_date') ? undefined : (json['subscription_start_date'] === null ? null : new Date(json['subscription_start_date'])),
        'affiliate_code': !exists(json, 'affiliate_code') ? undefined : json['affiliate_code'],
    };
}

export function ControlcenterMelcoControlCenterModelsUserLicenseToJSON(value?: ControlcenterMelcoControlCenterModelsUserLicense | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product_code': value.product_code,
        'subscription_code': value.subscription_code,
        'referral_code': value.referral_code,
        'version_id': value.version_id,
        'email_address': value.email_address,
        'is_validate_only': value.is_validate_only,
        'assign_license': value.assign_license,
        'language': value.language,
        'melco_customer_id': value.melco_customer_id,
        'subscription_start_date': value.subscription_start_date === undefined ? undefined : (value.subscription_start_date === null ? null : value.subscription_start_date.toISOString()),
        'affiliate_code': value.affiliate_code,
    };
}


